
export enum AssignmentStatus {
    NotStarted = 1,
    InProgress,
    Complete
}

export enum StripeTransactionType {
  Initial = 1,
  AddStudent,
  EditStudent,
  UniversalScreenerConversion
}

export enum SaveStatus {
    Success = 1,
    Failed = 2
}

export enum AssignmentType {
    Module = 1,
    Lesson, 
    Test
}

export enum ElementSubType {
    PreTest = 1,
    PostTest
}

export enum ProgramAccessType {
    TeacherCompanion = 4,
    Dyslexia,
    MindPlayLiteracy,
    ComprehensiveReadingCourse 
}

export enum ResourceType {
    Documents = 1,
    ExternalLinks,
    Course,
    VowelSpeechSounds,
    ConsonantSpeechSounds,
}

export enum ActionEnum {
    NewTab = 1,
    Download,
    Modal
}

//// A provider for the action enums so we can use them in the templates
//@Injectable()
//export class ActionEnumProvider {
//    public NewTab: ActionEnum;
//    public Download: ActionEnum;
//    public Modal: ActionEnum;

//    constructor() {
//        this.NewTab = ActionEnum.NewTab;
//        this.Download = ActionEnum.Download;
//        this.Modal = ActionEnum.Modal;
//    }
//}
